import {Heading} from "@/components/ui/heading";
import React from "react";

const PageBanner = ({ title, slug }) => {

    const images = {
        'about-us': require('../assets/images/banners/about-us-banner.jpg'),
        'affiliate-program': require('../assets/images/banners/affiliate-program-banner.jpg'),
        'ai-virtual-assistant': require('../assets/images/banners/ai-virtual-assistant-banner.jpg'),
        'training': require('../assets/images/banners/training-banner.jpg'),
        'training-fundamental-analysis': require('../assets/images/banners/training-banner.jpg'),
        'training-technical-analysis': require('../assets/images/banners/training-banner.jpg'),
        'training-long-position': require('../assets/images/banners/training-banner.jpg'),
        'training-short-position': require('../assets/images/banners/training-banner.jpg'),
        'support': require('../assets/images/banners/support-banner.jpg'),
        'support-video': require('../assets/images/banners/support-banner.jpg'),
        'support-ai': require('../assets/images/banners/support-banner.jpg'),
        'support-online': require('../assets/images/banners/support-banner.jpg'),
        'support-discord': require('../assets/images/banners/support-banner.jpg'),
        'contact': require('../assets/images/banners/contact-banner.jpg'),
    }

    // console.log(images[slug])

    const style = {
        backgroundImage: images[slug] ? `url(${images[slug]})` : undefined,
        backgroundPosition: ['support', 'support-video', 'support-ai', 'support-online', 'support-discord'].includes(slug) ? "center" : undefined,
    };

    return (
        <section className="page-banner" style={style}>
            <div className="generic-container">
                <Heading level={1}>
                    {title}
                </Heading>
            </div>
        </section>
    )
}

export default PageBanner;